export interface ChildItem {
  id?: number | string;
  name?: string;
  icon?: any;
  children?: ChildItem[];
  item?: any;
  url?: any;
  permission?: string;
  color?: string;
  isPro?: boolean;
}

export interface MenuItem {
  heading?: string;
  name?: string;
  icon?: any;
  id?: number;
  to?: string;
  items?: MenuItem[];
  children?: ChildItem[];
  url?: any;
  isPro?: boolean;
}

import { uniqueId } from 'lodash';

export const navItems = [
  {
    permission: 'dashboard',
    url: '/dashboard',
  },
  {
    permission: 'users',
    url: '/users',
  },
  {
    permission: 'template',
    url: '/template',
  },

  {
    url: '/moderation',
    permission: 'moderation',
  },
  {
    url: '/verificatons',
    permission: 'verificatons',
  },
  {
    url: '/flag',
    permission: 'flag',
  },
  {
    url: '/news',
    permission: 'news',
  },
  {
    url: '/deleted',
    permission: 'deleted',
  },
  {
    url: '/deactivated',
    permission: 'deactivated',
  },
  {
    url: '/feedback',
    permission: 'feedback',
  },
  {
    url: '/reports',
    permission: 'reports',
  },
  {
    permission: 'template',
    url: '/template',
  },
  {
    permission: 'blogs',
    url: '/blogs',
  },

  {
    permission: 'notification',
    url: '/notification',
  },
  {
    permission: 'sendNotification',
    url: '/sendNotification',
  },

  {
    permission: 'sendEmail',
    url: '/sendEmail',
  },

  {
    permission: "parameter",
    url: '/parameter',
  },
  {
    permission: "my-users",
    url: '/my-users',
  },
  {
    permission: "roles",
    url: '/roles',
  },
  {
    permission: "credit-package",
    url: '/credit-package',
  },
  {
    permission: "transactions",
    url: '/transactions',
  },
  {
    permission: "cities",
    url: '/cities',
  },
]
export const navItemsList = [
  {
    name: 'Dashboard',
    icon: 'solar:diagram-down-bold',
    id: uniqueId(),
    permission: 'dashboard',
    url: '/dashboard',
  },
  {
    name: 'Users',
    icon: 'solar:user-broken',
    id: uniqueId(),
    url: '/users',
    permission: 'users',
    isPro: false,
  },
  {
    name: 'Moderation',
    icon: 'solar:clapperboard-edit-broken',
    id: uniqueId(),
    url: '/moderation',
    permission: 'moderation',
    isPro: false,
  },
  {
    name: 'Verifications',
    icon: 'solar:verified-check-broken',
    id: uniqueId(),
    url: '/verificatons',
    permission: 'verificatons',
    isPro: false,
  },
  {
    name: 'Flag Users',
    icon: 'material-symbols:japanese-flag-outline-rounded',
    id: uniqueId(),
    url: '/flag',
    permission: 'flag',
    isPro: false,
  },

  {
    name: 'Deleted Account',
    icon: 'material-symbols:breaking-news-alt-1-outline',
    id: uniqueId(),
    url: '/deleted',
    permission: 'deleted',
    isPro: false,
  },
  {
    name: 'Deactivated Users',
    icon: 'solar:user-block-broken',
    id: uniqueId(),
    url: '/deactivated',
    permission: 'deactivated',
    isPro: false,
  },
  {
    name: 'Feedback',
    icon: 'solar:chat-square-like-broken',
    id: uniqueId(),
    url: '/feedback',
    permission: 'feedback',
    isPro: false,
  },
  {
    name: 'Reports',
    icon: 'solar:document-text-broken',
    id: uniqueId(),
    url: '/reports',
    permission: 'reports',
    isPro: false,
  },


  {
    name: 'System Controls',
    icon: 'solar:settings-outline',
    id: uniqueId(),
    permission: '',
    children: [{
      name: 'News',
      icon: 'solar:book-bookmark-bold-duotone',
      id: uniqueId(),
      url: '/news',
      permission: 'news',
      isPro: false,
    },
    {
      name: 'Blogs',
      icon: 'solar:clapperboard-play-broken',
      id: uniqueId(),
      permission: 'blogs',
      url: '/blogs',
    },
    {
      name: 'Parameter',
      icon: 'solar:tuning-2-line-duotone',
      id: uniqueId(),
      permission: "parameter",
      url: '/parameter',
    },
    {
      name: 'Credit Packages',
      icon: 'solar:wallet-money-bold-duotone',
      id: uniqueId(),
      permission: "credit-package",
      url: '/credit-package',
    },
    {
      name: 'Transactions',
      icon: 'solar:card-transfer-bold-duotone',
      id: uniqueId(),
      permission: "transactions",
      url: '/transactions',
    },
    {
      name: 'City Pages',
      icon: 'solar:map-point-wave-line-duotone',
      id: uniqueId(),
      permission: "cities",
      url: '/cities',
    },]
  },

  {
    name: 'Notification Management',
    icon: 'solar:bell-bing-outline',
    id: uniqueId(),
    children: [{
      name: 'Notification',
      icon: 'solar:clipboard-list-outline',
      id: uniqueId(),
      permission: 'notification',
      url: '/notification',
    },
    {
      name: 'Template',
      icon: 'solar:code-file-broken',
      id: uniqueId(),
      permission: 'template',
      url: '/template',
    }, {
      name: 'Send Notification',
      icon: 'solar:bell-off-outline',
      id: uniqueId(),
      permission: 'sendNotification',
      url: '/sendNotification',
    },

    {
      name: 'Send Email',
      icon: 'solar:case-outline',
      id: uniqueId(),
      permission: 'sendEmail',
      url: '/sendEmail',
    },]
  },




  {
    name: 'Sassy Mangement',
    icon: 'solar:hearts-bold',
    id: uniqueId(),
    children: [
      {
        name: 'My  Users',
        icon: 'solar:user-heart-bold',
        id: uniqueId(),
        permission: "my-users",
        url: '/my-users',
      },
      {
        name: 'Roles',
        icon: 'solar:lock-keyhole-outline',
        id: uniqueId(),
        permission: "roles",
        url: '/roles',
      },]
  },


]


const SidebarContent: MenuItem[] = [
  {
    children: navItemsList,
  },
];

export default SidebarContent;
